module.exports = __webpack_public_path__ + "static/media/linkedin.04cc6f8c.svg";